require('bootstrap-treeview/dist/bootstrap-treeview.min');

var Marionette = require('backbone.marionette');
var SnomedCollection = require('../../collections/snomed-collection.js');

var SnomedTreeView = Marionette.View.extend({
        template: require('../../templates/medicals/snomed-tree.html'),

        apiUrl: 'https://snomed.reviewandsign.org/snomed/en-edition/v20140731/concepts/',
        tree: [],

        ui: {
            selected: '#selected'
        },

        templateContext: function () {
            var that = this;
            return {

            };
        },

        initialize: function (options) {
            _.bindAll(this, 'findAppendable', 'renderTree', 'addTreeNode', 'collectionToTree', 'fetchNode');

            if (options) {
                this.showHead = options.showHead || false;
                this.parent = options.parent;
            }
            this.collection = new SnomedCollection([], {
                parent: this.parent,
                children: true
            });
            this.collection.fetch({success: this.addTreeNode});
        },

        renderTree: function(){
            var that = this;
            $('#tree').treeview({
                data: that.tree,
                enableLinks: false,
                showTags: false,
                levels: 10
            });

            $('#tree').on('nodeSelected', function(event, data) {
                if (!data.isLeafStated){
                    var node = (that.findAppendable(undefined, data.conceptId) || {});
                    if (data.state.expanded){
                        node.expanded = false;
                        node.state.expanded = false;
                        $('#tree').treeview('collapseNode', [data]);
                    } else {
                        node.expanded = true;
                        node.state.expanded = true;
                        that.fetchNode(event, node);
                        $('#tree').treeview('expandNode', [data, { levels: 1, silent: true } ]);
                    }
                } else {
                    that.triggerMethod('nodeSelected', data);
                }
            });

            $('#tree').on('nodeExpanded', function(event, data) {
                var node = (that.findAppendable(undefined, data.conceptId) || {})
                node.expanded = true;
                node.state.expanded = true;
                that.fetchNode(event, node);
            });

            $('#tree').on('nodeCollapsed', function(event, data) {
                var node = (that.findAppendable(undefined, data.conceptId) || {});
                node.expanded = false;
                node.state.expanded = false;
                node.nodes.forEach(function (child) {
                    $('#tree').treeview('collapseNode', [ child, { silent: true, ignoreChildren: false } ]);
                });
            });
        },

        fetchNode: function (event, data) {
            var that = this;
            if (!data.isLeafStated && (data.nodes || []).length == 0){
                this.collection = new SnomedCollection([], {
                    parent: data.conceptId,
                    children: true
                });
                this.collection.fetch({success: function () {
                    that.addTreeNode(data.conceptId);
                }});
            }
        },

        addTreeNode: function (parentId) {
            var subtree = this.collectionToTree(this.collection.toJSON());
            if (this.tree.length == 0){
                this.tree = subtree;
            } else {
                var node = this.findAppendable(undefined, parentId);
                node.nodes = subtree;
                node.state.expanded = node.expanded;
            }
            this.renderTree();
        },

        collectionToTree: function(collection){
            var that = this;
            var tree = [];
            if ((collection || []).length == 0){
                return undefined;
            }
            collection.forEach(function(concept){
                tree.push({
                    conceptId: concept.conceptId,
                    text: concept.defaultTerm,
                    nodes: concept.isLeafStated ? undefined : [],
                    isLeafStated: concept.isLeafStated,
                    state:{
                        expanded: concept.expanded === undefined ? false : concept.expanded
                    }
                });
            });
            return _.sortBy(tree, function(o) { return o.text; });
        },

        findAppendable: function (head, nodeId) {
            if (!head){
                head = {nodes: this.tree}
            }
            if (head.conceptId == nodeId) {return head};

            var foundNode;
            for (var i in (head.nodes || [])){
                foundNode = this.findAppendable(head.nodes[i], nodeId);
                if (foundNode){
                    break;
                }
            }
            return foundNode;
        }

    });

module.exports = SnomedTreeView;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/snomed-tree-view.js
// module id = 349
// module chunks = 0